export var AI_CHAT_INPUT = 'ai_chat_input';
export var AI_CHAT_SEND_CTA = 'ai_chat_send_cta';
export var USER_CHAT_MESSAGE = 'user_chat_message';
export var AI_CHAT_MESSAGE = 'ai_chat_message';
export var AI_ASSISTANT_RATING_CONTAINER = 'ai_assistant_rating_container';
export var AI_ASSISTANT_RATING_STAR = 'ai_assistant_rating_star';